import { render, staticRenderFns } from "./PageDictionary.vue?vue&type=template&id=2f3dce6a&"
import script from "./PageDictionary.vue?vue&type=script&lang=js&"
export * from "./PageDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3dce6a')) {
      api.createRecord('2f3dce6a', component.options)
    } else {
      api.reload('2f3dce6a', component.options)
    }
    module.hot.accept("./PageDictionary.vue?vue&type=template&id=2f3dce6a&", function () {
      api.rerender('2f3dce6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dictionary/PageDictionary.vue"
export default component.exports